import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Reveal } from "./Reveal";
import { Loader2, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Enter your email.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/subscribe`, { email });
      toast.success("You’re on the list. Watch your inbox.");
      setEmail("");
    } catch (err) {
      toast.error("Couldn’t sign you up. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section data-testid="newsletter-section" className="border-y-2 border-paper bg-ink text-paper">
      <div className="mx-auto flex max-w-[1400px] flex-col gap-10 px-5 py-20 sm:px-8 lg:flex-row lg:items-center lg:justify-between">
        <Reveal className="lg:max-w-xl">
          <p className="mb-3 font-mono text-xs uppercase tracking-[0.25em] text-orange">/ Newsletter</p>
          <h2 className="font-bebas text-5xl uppercase leading-[0.9] tracking-tight sm:text-6xl">
            Dispatches from the field.
          </h2>
          <p className="mt-4 font-mono text-sm text-paper/60">
            Product drops, playbooks for street teams, and market intel. No spam — just the good stuff.
          </p>
        </Reveal>

        <Reveal delay={0.1} className="w-full lg:w-[420px]">
          <form data-testid="newsletter-form" onSubmit={submit} className="flex flex-col gap-3 sm:flex-row">
            <input
              data-testid="newsletter-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@email.com"
              className="w-full border-2 border-paper bg-ink px-4 py-4 font-mono text-sm text-paper placeholder:text-paper/40 focus:outline-none focus:border-orange transition-colors"
            />
            <button
              type="submit"
              data-testid="newsletter-submit"
              disabled={loading}
              className="flex items-center justify-center gap-2 whitespace-nowrap bg-orange px-6 py-4 font-mono text-xs font-bold uppercase tracking-[0.2em] text-paper transition-transform duration-200 hover:-translate-y-0.5 disabled:opacity-60"
            >
              {loading ? <Loader2 className="animate-spin" size={16} /> : <ArrowRight size={16} />}
              Sign up
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
};
